import React, { useState, useEffect, useReducer } from 'react';
import moment from 'moment';

export default React.forwardRef((props, ref) => {
  const { type } = props;
  return (
    <div className="stat-body">
     delivery
    </div >)
});
